import { render } from "./Notes14.vue?vue&type=template&id=079a4c66&scoped=true"
import script from "./Notes14.vue?vue&type=script&lang=js"
export * from "./Notes14.vue?vue&type=script&lang=js"

import "./Notes14.vue?vue&type=style&index=0&id=079a4c66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079a4c66"]])

export default __exports__